<template>
  <div class="ime-8-by-4 container">
    <div class="row">
      <div :class="{'col-sm-12': true, 'col-md-8': !direction || direction === 84, 'col-md-4': direction === 48}">
        <div class="row">
          <slot name="slot1"></slot>
        </div>
      </div>
      <div :class="{'col-sm-12': true, 'col-md-4': !direction || direction === 84, 'col-md-8': direction === 48}">
        <div class="row">
          <slot name="slot2"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EightByFour",
  props: {
    obj: Object,
    // {
		// 		type: 'EightByFour', //String - name of component
		// 		variant: String, //class name for variant
		// 		classes: '', //string catch all to add any class names needed to parent container
		// 		transitions: {
		// 			aos: { //fill out if we are using aos
		// 				name: 'fadeInUp',
		// 				delay: '',
		// 				duration: ''
		// 			},
		// 			gsap: { // fill out if component requires animation with multiple child elements
		// 				components: [], // handle on the animated items within component. Where best to put this?
		// 				script: ''
		// 			}
		// 		},
		// 		presentation: {
    //      direction: Number //84 or 48
    //    },
		// 		content: { // component content and images }
		// 	}
  },
  computed: {
    direction () {
      const d = !this.obj ? null : !this.obj.presentation ? null : !this.obj.presentation.direction ? null : this.obj.presentation.direction
      return d
    }
  }
}
</script>

<style lang="scss" scoped>
  .ime-8-by-4 {

  }
</style>